import type { Selector, State as S } from 'model/State';
import { OverviewWithOrgChildren } from '../models';
import Progress from 'redux-progress';

export const selectCMTSelfServeLink: Selector<unknown> = (state: S) =>
  state.mac.accountId.CMTSelfServeLink?.ifSuccess((r) => r);

export const selectChildrenOverviews: Selector<unknown> = (state: S) =>
  state.mac.accountId.childrenOverviews?.ifSuccess((r) => r);

export const selectTrackedElsewhere: (state: S, accountId: string) => boolean = (
  state: S,
  accountId: string,
) => state.mac.accountId.trackedElsewhere?.[accountId]?.ifSuccess((r) => r);

export const selectIsOnBehalfOfEmail: Selector<unknown> = (state: S) =>
  state.mac.accountId.isOnBehalfOfEmail?.ifSuccess((r) => r);

export const selectOverviewWithOrgChildren: Selector<OverviewWithOrgChildren> = (state: S) =>
  state.mac.accountId.overviewWithOrgChildren?.ifSuccess<OverviewWithOrgChildren>((r) => {
    if (Array.isArray(r)) return r;
    if (typeof r === 'object' && r && 'overviews' in r) return r.overviews;

    return [];
  }) || [];

export const selectCustomerAccountOverviewsData: Selector<unknown> = (state: S) =>
  state.mac.accountId.customerAccountOverviews?.ifSuccess((r) => r) || null;

export const selectCustomerAccountOverviews: Selector<OverviewWithOrgChildren[]> = (state: S) =>
  state.mac.accountId.customerAccountOverviews?.ifSuccess<OverviewWithOrgChildren[]>((r) => {
    if (Array.isArray(r)) return r as unknown as OverviewWithOrgChildren[];
    if (typeof r === 'object' && r && 'overviews' in r)
      return r.overviews as unknown as OverviewWithOrgChildren[];

    return [];
  }) || [];

export const selectIsMACSiteApplicableForConcession: Selector<unknown> = (state: S) =>
  state.mac.accountId.isSiteApplicableForConcession?.ifSuccess((r) => r);

export const selectIsMACSiteOnConcession = (state: S, accountId: string) =>
  state.mac.accountId.isSiteOnConcession?.[accountId]?.ifSuccess((r) => r);

export const selectIsArchivedAccount: Selector<unknown> = (state: S) =>
  state.mac.accountId.isArchivedAccount?.ifSuccess((r) => r);

export const selectAccountHistory: (state: S, accountId) => {} = (state: S, accountId) =>
  state.mac.accountId.accountHistory?.[accountId]?.ifSuccess((r) => r);

export const selectAccountHistoryAsPartner: (state: S, accountId) => {} = (state: S, accountId) =>
  state.mac.accountId.accountHistoryAsPartner?.[accountId]?.ifSuccess((r) => r);

export const selectPricingPlanOverview: (state: S, accountId) => {} = (state: S, accountId) =>
  state.mac.accountId.pricingPlanAccountOverview?.[accountId]?.ifSuccess((r) => r);

export const selectCreditCardUpdatableAccounts: Selector<unknown> = (state: S) =>
  state.mac.accountId.creditCardUpdatableAccounts?.ifSuccess((r) => r);

export const selectRenewalTotal: (state: S, accountId) => string = (state: S, accountId) =>
  state.mac.accountId.renewalTotal?.[accountId]?.ifSuccess((r) => r);

export const selectIsHostedAccountProvisioning: (state: S, accountId) => {} = (
  state: S,
  accountId,
) => state.mac.accountId.isHostedAccountProvisioning?.[accountId]?.ifSuccess((r) => r);

export const selectUpdatedSid: (state: S) => Progress<unknown> | undefined = (state: S) =>
  state.mac.accountId.updateSid;

export const selectIsSuspended: Selector<unknown> = (state: S) =>
  state.mac.accountId.isSuspended?.ifSuccess((r) => r);

export const selectPostedCreditCardDetails: Selector<unknown> = (state: S) =>
  state.mac.accountId.postedCreditCardDetails?.ifSuccess((r) => r);

export const selectCreatedPersistedLicense: Selector<any> = (state: S) =>
  state.mac.accountId.createdPersistedLicense;

export const selectCancelledAutoRenew = (state: S) => state.mac.accountId.cancelledAutoRenew;

export const selectEditedLicenseNameInline = (state: S) =>
  state.mac.accountId.editedLicenseNameInline;

export const selectEditedLicenseNameInlineResult = (state: S) =>
  state.mac.accountId.editedLicenseNameInline?.ifSuccess((r) => r);

export const selectCurrencyOnReconcilableValidation = (state: S) =>
  state.mac.accountId.currencyOnReconcilableValidation;

export const selectCurrencyOnReconcilableValidationResult = (state: S) =>
  state.mac.accountId.currencyOnReconcilableValidation?.ifSuccess((r) => r);
